import * as R from 'ramda'
import { createStore, applyMiddleware, combineReducers, compose } from 'redux'

import reducers from './reducers'
import middlewares from './middlewares'

export default (state, history, createReducers = () => ({}), createMiddlewares = () => ([]), epics = []) => {
  return createStore(
    combineReducers(reducers(history, createReducers)),
    state,
    compose(
      applyMiddleware(...middlewares(state, history, createMiddlewares, epics)),
      window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__() : R.identity
    )
  )
}
